import * as React from "react";
import { IPanelProps, Panel } from "../../core/decorators/Panel";
import SeatAssignmentConfig from "./SeatAssignmentConfig";
import SeatsPurchased from "./components/SeatsPurchased";
import OrganizationEnrollments from "./entities/OrganizationEnrollments";
import { ID } from "common/form/fields/entitySelect/IEntitySelect";
import { Query } from "core/api/typedQuery";
import Loading from "common/fragments/Loading";
import NonIdealState from "common/fragments/NonIdealState";
import labelProvider from './SeatAssignment.labels';
import ServiceRegistry from "core/util/ServiceRegistry";
import ILocalCacheService from "core/service/cache/ILocalCacheService";

const { Labels } = labelProvider;

interface IOrganizationEnrollmentParam {
	organizationIds?: ID[]
	selectedOrganizationId:number
}

let SeatDistributionQuery = Query.queryMany<OrganizationEnrollments,IOrganizationEnrollmentParam>(OrganizationEnrollments);

@Panel({
	id: "seatAssignment",
	configClass: SeatAssignmentConfig,
	pageParams: true
})
export class SeatAssignment extends React.Component<IPanelProps<SeatAssignmentConfig>> {
	state={reload:false}
	public render() {
		const params = {
			selectedOrganizationId: ServiceRegistry.get(ILocalCacheService).getNumber("orgId")
		};
		if(this.state.reload){
			console.log("renderSeatAssignment-reoload ")
			//SeatDistributionQuery=Query.queryMany<OrganizationEnrollments,IOrganizationEnrollmentParam>(OrganizationEnrollments);
		}
		SeatDistributionQuery=Query.queryMany<OrganizationEnrollments,IOrganizationEnrollmentParam>(OrganizationEnrollments);

		return (
			<SeatDistributionQuery key="query" params={params} autoLoad={true}>
				{({ data, loading }) => {
					if (loading) {
						return <Loading key="loading" />;
					}
					if (!data) {
						return (
							<NonIdealState
								key="empty"
								title={
									<Labels.SeatAssignmentEmpty
									/>
								}
								description={
									<Labels.DescriptionEmpty
									/>
								}
							/>
						);
					}
					return (
						console.log(data),
						<div>{data.map(this.renderEntry)}</div>
					);
				}}
			</SeatDistributionQuery>
		);
	}

	private renderEntry = (organizationEnrollments: OrganizationEnrollments) => {
		return (
			<SeatsPurchased organizationEnrollments={organizationEnrollments}   reload={this.reloadPage.bind(this)}/>
		);
	};

	private reloadPage(reload:boolean){
		if(reload){
			this.setState({reload:true})
		}
	}
}



// WEBPACK FOOTER //
// ./src/panels/checkout/SeatAssignment.panel.tsx